module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h2', {
    staticClass: "center2"
  }, [_vm._v("To my parents,")]), _vm._v(" "), _c('h2', {
    staticClass: "center0"
  }, [_vm._v("Levan and Marina Mikaberidze,")]), _vm._v(" "), _c('h2', {
    staticClass: "center0"
  }, [_vm._v("who gave up so much for their children")]), _vm._v(" "), _c('h2', {
    staticClass: "center0"
  }, [_vm._v("and instilled in them a passion for learning.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180d86a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_dedication.vue
// module id = 66
// module chunks = 0